import classNames from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import SoundIcon from '../../icons/SoundIcons/SoundIcon';
import MuteIndicatorIcon from '../../icons/SoundIcons/IndicatorIcons/MuteIndicatorIcon';
import styles from './styles.module.scss';

export interface IUnmuteButtonProps {
  onClick: () => void;
  visible: boolean;
}

const UnmuteButton = ({ onClick, visible }: IUnmuteButtonProps) => {
  const { t } = useTranslation('common');

  return (
    <button
      aria-label={`${t('general.unmute')}`}
      className={classNames(styles.container, { [styles.hide]: !visible })}
      onClick={() => onClick()}
      onKeyDown={() => onClick()}
      onMouseDown={(event) => event.preventDefault()}
      tabIndex={0}
    >
      <div className={styles.content}>
        <div className={styles.soundIcon}>
          <SoundIcon />
          <MuteIndicatorIcon />
        </div>
        {t('general.unmute')}
      </div>
    </button>
  );
};

export default UnmuteButton;
